"use client"

import { useState, useEffect } from "react"
import { logOut } from "../../common/util"
import API,{URL_PATH} from "../../services/API" // Import your API service
import { colors } from "@mui/material"

export default function UserProfile() {
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    mobile: ""
  })
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [deleteConfirmation, setDeleteConfirmation] = useState("")
  const [isDeleting, setIsDeleting] = useState(false)

  // Load user data from localStorage when component mounts
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"))
    if (storedUser) {
      setUserData({
        name: storedUser.name || "",
        email: storedUser.email || "",
        mobile: storedUser.mobile || ""
      })
    }
  }, [])

  const handleLogout = (e) => {
    e.preventDefault()
    logOut() // Call your logout function
  }

  const handleDeleteAccount = async () => {
    if (deleteConfirmation.toLowerCase() !== "delete") {
      alert('Please type "delete" to confirm')
      return
    }

    setIsDeleting(true)
    try {
      const { status, message, data } = await API(
        this,
        "post",
        URL_PATH.deleteAccount,
        {}
      );
      if (status != "success") this.props.okDialog(message);
      else logOut(this);

      // if (response.status === "success") {
      //   logOut() // Log out after successful deletion
      // } else {
      //   alert(response.message || "Failed to delete account")
      // }
    } catch (error) {
      console.error("Error deleting account:", error)
      alert("An error occurred while deleting your account")
    } finally {
      setIsDeleting(false)
      setShowDeleteModal(false)
    }
  }

  return (
    <div style={{
      maxWidth: "400px",
      margin: "0 auto",
      padding: "30px",
      borderRadius: "8px",
      
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      backgroundColor: "#0000",
      border: "1px solid #FFC857",
    }}>
      <h4 style={{ 
        textAlign: "center", 
        marginBottom: "20px",
        color: "#FFFFFF" 
      }}>
        Login Details
      </h4>
      
      <form onSubmit={handleLogout}>
        <div style={{ marginBottom: "15px" }}>
          <label htmlFor="name" style={{ display: "block", marginBottom: "5px", color: "#FFFFFF" }}>Username</label>
          <input
            type="text"
            id="name"
            name="name"
            value={userData.name}
            readOnly
            style={{
              backgroundColor: "#0000",
              width: "100%",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
              color: "#FFFFFF",
              cursor: "not-allowed"
            }}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label htmlFor="email" style={{ display: "block", marginBottom: "5px", color: "#FFFFFF" }}>Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={userData.email}
            readOnly
            style={{
              width: "100%",
              backgroundColor: "#0000",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
              color: "#FFFFFF",
              cursor: "not-allowed"
            }}
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label htmlFor="mobile" style={{ display: "block", marginBottom: "5px", color: "#FFFFFF" }}>Phone Number</label>
          <input
            type="tel"
            id="mobile"
            name="mobile"
            value={userData.mobile}
            readOnly
            style={{
              width: "100%",
              backgroundColor: "#0000",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
              color: "#FFFFFF",
              cursor: "not-allowed"
            }}
          />
        </div>

        <button
          type="submit"
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: "#041A29",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "16px",
            marginTop: "10px"
          }}
        >
          Logout
        </button>

        <button
          type="button"
          onClick={() => setShowDeleteModal(true)}
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: "#BB0A21",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "16px",
            marginTop: "10px"
          }}
        >
          Delete Account
        </button>
      </form>

      {/* Delete Account Modal */}
      {showDeleteModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: colors.grey,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: "#041A29",
            padding: "20px",
            borderRadius: "8px",
            width: "90%",
            maxWidth: "400px"
          }}>
            <h3 style={{ color: "#BB0A21", marginBottom: "15px" }}>Delete Account</h3>
            <p style={{ color: "#FFFFFF", marginBottom: "20px" }}>
              This action cannot be undone. All your data will be permanently deleted.
              <br /><br />
              Type <strong>"delete"</strong> to confirm:
            </p>
            
            <input
              type="text"
              value={deleteConfirmation}
              onChange={(e) => setDeleteConfirmation(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                marginBottom: "20px",
                borderRadius: "4px",
                border: "1px solid #505050",
                backgroundColor: "#0000",
                color: "#FFFFFF"
              }}
              placeholder="Type 'delete' to confirm"
            />
            
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <button
                onClick={() => {
                  setShowDeleteModal(false)
                  setDeleteConfirmation("")
                }}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #FFC857",
                  backgroundColor: "#041A29",
                  color: "white",
                
                  borderRadius: "4px",
                  cursor: "pointer"
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteAccount}
                disabled={isDeleting || deleteConfirmation.toLowerCase() !== "delete"}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#BB0A21",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  opacity: (isDeleting || deleteConfirmation.toLowerCase() !== "delete") ? 0.7 : 1
                }}
              >
                {isDeleting ? "Deleting..." : "Delete Account"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}